import React, { useState } from 'react';
import AIAssistantPopup from './AIAssistantPopup';
import './AIFloatingButton.css';
import mikoAvatar from '../../felix_icon.jpg';

const AIFloatingButton = ({ onSuggestStory, onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className="ai-floating-button"
        onClick={() => setIsOpen(prev => !prev)}
        title="Chat with Archie"
      >
        <img
          src={mikoAvatar}
          alt="Archie"
          style={{
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            objectFit: 'cover',
            objectPosition: 'center top'
          }}
        />
      </button>

      {/* keep mounted to preserve size; toggle visibility instead */}
      <div style={{ display: isOpen ? 'block' : 'none' }}>
        <AIAssistantPopup
          onClose={() => setIsOpen(false)}
          onSuggestStory={onSuggestStory}
          onNavigate={onNavigate}
        />
      </div>
    </>
  );
};

export default AIFloatingButton;